// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '2766b11c75c12ec4d698fd6fdfe260496bec2ea7';
export const BUILD_NUMBER = '278';
export const BUILD_TIMESTAMP = '2026-10-26T07:26:04.914Z';
